import script from "./BeneficiaryPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./BeneficiaryPage.vue?vue&type=script&setup=true&lang=ts"

import "./BeneficiaryPage.vue?vue&type=style&index=0&id=53410122&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53410122"]])

export default __exports__